import { CHAT_BOOKINGS, ChatBooking } from "../../db/chat";
import { RealtimeReference } from "../../db/common";
import { BaseDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Booking Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatBookingService extends BaseDatabaseService<ChatBooking> {
    protected getBasePath(): string {
        return CHAT_BOOKINGS;
    }

    //make it public for sub on change for FE
    public getEntityRef(bookingId: string): RealtimeReference {
        return super.getEntityRef(bookingId)
    }
}
